import { Col, Row } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { dateCommon } from "../../helpers/common";
import { getDayInMonth } from "../../services/chamcong";
import { layDanhMucNhanVien } from "../../services/danhmuc";
import { chucVu } from "../../constants";
import { NhanVienResponse } from "../../models/nhanvien/NhanVien";
import { useSelector } from "react-redux";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:landscape;
      background-color: white;
      margin-top: 0.5cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    .ant-table-tbody {
        padding: 0 !important;
    }
    .ant-table-tbody > tr > td {
        padding: 0 !important;
    }
    .atn-table-summary {
        display: table-header-group;
    }
  }
`;

const InChamCongNgoaiGio = ({ ThongKeChamCong, thangNam }: { ThongKeChamCong: any, thangNam: any }) => {

    const [dataTable, setDataTable] = useState<any>();

    const [columns, setColumns] = useState<any>();
    const [chanhVP, setChanhVP] = useState<NhanVienResponse>();
    const [giamDoc, setGiamDoc] = useState<NhanVienResponse>();
    const user = useSelector((state: any) => state.auth.currentUser);
    const now = new Date();
    type dataType = {
        key?: any,
        hoVaTen?: any,
        STT?: any,
        1?:any,
        2?:any,
        3?:any,
        4?:any,
        5?:any,
        6?:any,
        7?:any,
        8?:any,
        9?:any,
        10?:any,
        11?:any,
        12?:any,
        13?:any,
        14?:any,
        15?:any,
        16?:any,
        17?:any,
        18?:any,
        19?:any,
        20?:any,
        21?:any,
        22?:any,
        23?:any,
        24?:any,
        25?:any,
        26?:any,
        27?:any,
        28?:any,
        29?:any,
        30?:any,
        31?: any,
        ngayThuong?:any,
        cuoiTuan?:any,
        ngayLe?:any
    };
    const layChanhVanPhong = async () => {
        let rs = await layDanhMucNhanVien();
        setChanhVP(rs.filter((item: any) => item.idChucVu == chucVu.chanhVanPhong)[0])
        setGiamDoc(rs.filter((item: any) => item.idChucVu == chucVu.giamDoc)[0])
    }
    const layDuLieu = async () => {
        var data: dataType[] = [];
        var dsNgoaiGio = ThongKeChamCong.filter((x: any) => x.ngoaiGio != null)
        if (dsNgoaiGio.length > 0) {
            dsNgoaiGio.map((item: any, index: any) => {
                data.push({
                    key: index + 1,
                    STT: index + 1,
                    hoVaTen: item.hoTen,
                    1: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "01")[0].soGio,
                    2: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "02")[0].soGio,
                    3: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "03")[0].soGio,
                    4: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "04")[0].soGio,
                    5: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "05")[0].soGio,
                    6: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "06")[0].soGio,
                    7: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "07")[0].soGio,
                    8: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "08")[0].soGio,
                    9: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "09")[0].soGio,
                    10: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "10")[0].soGio,
                    11: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "11")[0].soGio,
                    12: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "12")[0].soGio,
                    13: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "13")[0].soGio,
                    14: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "14")[0].soGio,
                    15: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "15")[0].soGio,
                    16: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "16")[0].soGio,
                    17: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "17")[0].soGio,
                    18: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "18")[0].soGio,
                    19: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "19")[0].soGio,
                    20: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "20")[0].soGio,
                    21: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "21")[0].soGio,
                    22: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "22")[0].soGio,
                    23: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "23")[0].soGio,
                    24: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "24")[0].soGio,
                    25: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "25")[0].soGio,
                    26: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "26")[0].soGio,
                    27: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "27")[0].soGio,
                    28: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "28")[0].soGio,
                    29: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "29")[0] ? item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "29")[0].soGio:"",
                    30: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "30")[0] ? item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "29")[0].soGio:"",
                    31: item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "31")[0] ? item.ctcng.filter((x: any) => dateCommon.formatDate(x.ngay, "dd") == "29")[0].soGio : "",
                    ngayThuong: item.ngoaiGio.ngoaiGioNgayThuong,
                    ngayLe: item.ngoaiGio.ngoaiGioNgayLe,
                    cuoiTuan: item.ngoaiGio.ngoaiGioCuoiTuan,
                })
            })
        }
        setDataTable(data);
    }

    const layColumns = async () => {
        var data = await getDayInMonth(thangNam.getFullYear(), thangNam.getMonth() + 1);
        var columnsChildren: ColumnsType<dataType> = [];
        data.map((item: any, index: any) => {
            columnsChildren.push({
                title: item.day,
                key: item.day,
                align: 'center',
                children: [{
                    title: item.thu,
                    dataIndex: item.day,
                    key: item.thu,
                    align: 'center',
                }]
            });
        })
        var columnsCha: ColumnsType<dataType> = [
            {
                title: 'STT',
                dataIndex: 'STT',
                key: 'STT',
                align: 'center'
            },
            {
                title: 'Họ và tên',
                dataIndex: 'hoVaTen',
                key: 'hoVaTen',
            },
            {
                title: 'Ngày trong tháng',
                key: 'quyRaCongGio',
                align: 'center',
                children: columnsChildren
            },
            {
                title: 'Quy ra công (giờ)',
                key: 'quyRaCongGio',
                align: 'center',
                children: [{
                    title: 'Ngày làm việc',
                    dataIndex: 'ngayThuong',
                    key: 'ngayThuong',
                    align: 'center'
                },
                {
                    title: 'Ngày nghỉ',
                    dataIndex: 'cuoiTuan',
                    key: 'cuoiTuan',
                    align: 'center'
                },
                {
                    title: 'Ngày lễ',
                    dataIndex: 'ngayLe',
                    key: 'ngayLe',
                    align: 'center'
                }]
            },
        ];
        setColumns(columnsCha);
    }

    const emptyTextStyle = {
        color: 'black',
        fontWeight: 'bold',
        fontFamily: 'Times New Roman',
    };

    useEffect(() => {
        layColumns();
        layChanhVanPhong();
        layDuLieu();
    }, [ThongKeChamCong])

    return (
        <section>
            <div style={{ backgroundColor: 'white' }}>
                <PrintPage >
                    <div className="text-center pt-2">
                        <Row gutter={8}>
                            <Col span={12} >
                                <div style={{ fontFamily: 'Times New Roman' }}>ỦY BAN NHÂN DÂN THÀNH PHỐ<br /><label><span style={{ fontFamily: 'Times New Roman' }}> QUỸ ĐẦU TƯ PHÁT TRIỂN</span><hr style={{ borderTop: "1px solid", width: "60%", marginLeft: '12mm', marginTop: "1px", marginBottom: "2px" }} /> </label></div>
                            </Col>
                            <Col span={12}  >
                                <label style={{ fontFamily: 'Times New Roman' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span style={{ fontFamily: 'Times New Roman' }}>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} className="pt-4">
                                <label style={{ fontFamily: 'Times New Roman' }}>BẢNG TỔNG HỢP LÀM THÊM GIỜ <br /> Tháng {dateCommon.formatDate(thangNam, "MM")} năm {dateCommon.formatDate(thangNam, "yyyy")} </label>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col span="24">
                            <div className="card-primary">
                                <Table
                                    dataSource={dataTable}
                                    pagination={false}
                                    size="small"
                                    columns={columns}
                                    locale={{ emptyText: <span style={emptyTextStyle}>Không có dữ liệu</span> }}
                                    className="custom-table-anttd"

                                />
                            </div>
                        </Col>
                    </Row>
                    <div className="print-footer">
                        <div className="text-center" style={{ marginTop: '25px' }}>
                            <Row gutter={8}>
                                <Col span={8} >
                                </Col>
                                <Col span={8} >
                                </Col>
                                <Col span={8}  >
                                    <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Đà Nẵng, ngày {("0" + now.getDate()).slice(-2)} tháng {("0" + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}</div>
                                </Col>
                            </Row>
                            <Row gutter={8}>
                                <Col span={8} >
                                    <label style={{ fontFamily: 'Times New Roman' }}>Người lập</label>
                                </Col><Col span={8} >
                                    <label style={{ fontFamily: 'Times New Roman' }}>Chánh Văn phòng</label>
                                </Col>
                                <Col span={8}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>Giám đốc</label>
                                </Col>
                            </Row>
                        </div>
                        <div className="text-center" style={{ paddingTop: "100px" }}>
                            <Row gutter={8}>
                                <Col span={8}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>{user?.hoTen}</label>
                                </Col>
                                <Col span={8} >
                                    <label style={{ fontFamily: 'Times New Roman' }}>{chanhVP?.hoTen}</label>
                                </Col>
                                <Col span={8}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>{giamDoc?.hoTen}</label>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </PrintPage>
            </div>
        </section>
    )
}
export default InChamCongNgoaiGio;
